import React from "react";
import styles from "./BundleCard.module.scss";
import PricingFunctions from "common/PricingFunctions";
import { useSelector } from "react-redux";

const BundleCard = ({
    game,
    onClick,
    selected,
    isActive,
    onLearnMore,
    noButton,
    showInfoButton,
    compact,
}) => {
    const pricing = useSelector((state) => state.pricing);

    const storeBackground = game.meta?.storeBackground;
    const storeLogo = game.logo || game.meta?.storeLogo;
    const fallbackCard = game.meta?.storeCard;
    const tinyCard = game.meta?.tinyCard;
    const countryCode = pricing.countryCode;
    const currentPrice = PricingFunctions.getEffectiveGamePricing(countryCode, game)?.display;
    const bgColor = game.meta?.storeBackgroundColour || '#1a0a2e';

    const description = game.gameInfo?.descriptions?.[0]?.body || game.description || "";

    const handleLearnMore = (e) => {
        e.stopPropagation();
        if (onLearnMore) onLearnMore(e);
    };

    return (
        <div className={`${styles.gameCardWrapper} ${noButton ? styles.noButton : ''} ${selected ? styles.selected : ''} ${isActive ? styles.active : ''} ${compact ? styles.compact : ''}`}>
            <div className={styles.gameCard} onClick={onClick}>
                <div
                    className={styles.gameCardBackground}
                    style={compact ? {
                        backgroundImage: `url(${tinyCard || fallbackCard || ''})`,
                        backgroundColor: bgColor,
                    } : {
                        backgroundImage: storeBackground ? `url(${storeBackground})` : (fallbackCard ? `url(${fallbackCard})` : 'none'),
                        backgroundColor: bgColor,
                    }}
                >
                    {/* Logo overlay - only when we have separate layers (not in compact mode) */}
                    {!compact && storeLogo && storeBackground && (
                        <img className={styles.cardLogo} src={storeLogo} alt={game.name} />
                    )}

                    {/* Top-left: circle + connected "Selected" capsule (only in selection mode) */}
                    {selected && (
                        <div className={`${styles.selectionIndicator} ${styles.selected}`}>
                            <div className={styles.check}>
                                <span className={styles.tick}>&#10004;</span>
                            </div>
                            <span className={styles.selectedLabel}>Selected</span>
                        </div>
                    )}

                    {/* Mobile Learn More button (on active carousel card) */}
                    {isActive && (
                        <button className={styles.learnMoreMobile} onClick={handleLearnMore}>
                            LEARN MORE
                        </button>
                    )}

                    {/* Info button for grid cards */}
                    {showInfoButton && (
                        <button className={styles.infoBtn} onClick={handleLearnMore} aria-label="Game info">
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                                <circle cx="12" cy="12" r="10" />
                                <line x1="12" y1="16" x2="12" y2="12" />
                                <line x1="12" y1="8" x2="12.01" y2="8" />
                            </svg>
                        </button>
                    )}
                </div>
            </div>

            {/* Desktop info panel - slides out below active card */}
            {isActive && noButton && (
                <div className={styles.infoPanel}>
                    <span className={styles.gameName}>{game.name}</span>
                    <p className={styles.gameDescription}>{description}</p>
                    <div className={styles.infoPanelActions}>
                        <button className={styles.learnMoreBtn} onClick={handleLearnMore}>
                            LEARN MORE
                        </button>
                        {currentPrice && (
                            <span className={styles.gamePrice}>{currentPrice}</span>
                        )}
                    </div>
                </div>
            )}

        </div>
    );
};

export default BundleCard;
